<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-04-21 10:38:26
 * @Description: 
 * @LastEditors: fengxiaojing
-->
<template>
  <div>
    <el-row class="h-100" :class="isDarkStyle ? 'darkStyle' : ''">
      <el-col :span="showControl && leftBarSwitch ? 18 : 24" class="h-100 position-relative">
        <div id="DHVideoPlayer" class="m-t-5 w-100 h-100"></div>
      </el-col>
      <el-col :span="showControl && leftBarSwitch ? 6 : 0" class="h-100 p-5 w-50 position-relative">
        <el-switch
          @change="switchStatus"
          style="display: block;"
          v-model="activeName"
          active-color="#409eff"
          inactive-color="#c0c4cc"
          active-value="preview"
          inactive-value="backPlay"
          active-text="预览"
          inactive-text="回放"
        >
        </el-switch>
        <div class="control_item m-t-10" v-if="activeName === 'preview'">
          <div class="m-t-10">
            <p class="fz-12 m-b-10 text-color-white">云台速度</p>
            <el-select
              popper-class="document_select-popper"
              v-model="speed"
              size="mini"
              placeholder="请选择云台速度"
            >
              <el-option
                v-for="item in speedOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="m-t-10">
            <div class="tc">
              <img
                :disabled="!isBackPlay"
                class="controlImg controlImg_up cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('up', 1)"
                @mouseup="controlCamera('up', 0)"
              />
            </div>
            <div class="tc">
              <img
                class="controlImg cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('left', 1)"
                @mouseup="controlCamera('left', 0)"
              />
              <img
                class="controlImg controlImg_right cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('right', 1)"
                @mouseup="controlCamera('right', 0)"
              />
            </div>
            <div class="tc">
              <img
                class="controlImg controlImg_down cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('down', 1)"
                @mouseup="controlCamera('down', 0)"
              />
            </div>
          </div>
          <div>
            <p class="fz-12 m-b-10 text-color-white">云台变倍调整</p>
            <el-tooltip effect="dark" content="放大" placement="top" :open-delay="1000">
              <el-button
                type="primary"
                icon="el-icon-zoom-in"
                @mousedown.native="operateCamera('1', '1', '1')"
                @mouseup.native="operateCamera('0', '1', '1')"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="缩小" placement="top" :open-delay="1000">
              <el-button
                type="primary"
                icon=" el-icon-zoom-out"
                @mousedown.native="operateCamera('1', '1', '2')"
                @mouseup.native="operateCamera('0', '1', '2')"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import dhServer from '@/services/dhServer'
import fn from './js/factory.js'
export default {
  props: {
    videoId: {
      type: String,
      default: 'DHVideoPlayer',
    },
    num: {
      //子窗口个数
      type: Number,
      default: 1,
    },
    connectTime: {
      //尝试连接事件，默认60s，一定时间连接断开，并弹出下载插件提示。
      type: Number,
      default: 60,
    },
    downloadUrl: {
      //插件下载地址，ICC框架默认相对路径
      type: String,
      default: '/download/DHPlayer.zip',
    },
    showBar: {
      //是否显示下方控制栏。 true: 显示， false：隐藏
      type: Boolean,
      default: true,
    },
    noTip: {
      //是否需要下载提示,默认需要。如果非ICC平台/未引入antd，可置为true
      type: Boolean,
      default: true,
    },
    shieldClass: {
      //遮挡的元素class，尽量保证class元素的唯一
      type: Array,
      default() {
        return ['dh_document_select-popper']
      },
    },
    isDarkStyle: {
      type: Boolean,
      default: false,
    },
    showControl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      videoPlayer: null, // 播放器实例
      windowType: 0, // 播放器类型
      currentWindow: 0,
      osdInfo: '',
      publicKey: '',
      videoUrl: '',
      leftBarSwitch: true,
      backTimeRange: '',
      speed: 4,
      speedOptions: Object.freeze([1, 4, 6, 8]),
      isBackPlay: false,
      isPausePlay: false,
      backSpeed: 1,
      controlCameraList: Object.freeze({
        up: 1,
        down: 2,
        left: 3,
        right: 4,
      }),
      backPlayUrl: '',
      activeName: 'preview',
      playBackStartTime: '',
      playBackEndTime: '',
      DivisionMap: [1, 4, 6, 8, 9, 13, 16, 20, 25, 36, 64],
    }
  },
  computed: {
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    channelId() {
      const channelIdInfo = _.find(this.systemParams, { parameterCode: 'channelId' }) || {}
      return channelIdInfo.parameterValue
    },
  },
  mounted() {
    this.initVideo()
  },
  methods: {
    /**
     * @description: 切换直播or回放状态
     * @return {*}
     */

    switchStatus() {
      if (this.activeName === 'preview') {
        // 切换至直播状态
        this.windowType = 0
        this.initVideo()
      } else {
        // 切换至回放状态
        this.windowType = 1
        this.initVideo()
      }
    },
    /**
     * @description: 获取实时监控视频的方法
     * @return {*}
     */

    async livePreview(channelId) {
      const query = {
        data: {
          channelId,
          dataType: '1',
          streamType: '1',
        },
      }
      const res = await dhServer.livePreview(query)
      if (res && res.data) {
        const urlList = res.data.url.split('|')
        // 取外网的流
        return `${urlList[0]}?token=${res.data.token}&trackID=701`
      }
      return ''
    },

    /**
     * @description: 开始回放
     * @param {*} startTime
     * @param {*} endTime
     * @param {*} snum
     * @return {*}
     */

    async startPlay(startTime, endTime, snum) {
      startTime = startTime || parseInt(this.playBackStartTime / 1000)
      endTime = endTime || parseInt(this.playBackEndTime / 1000)
      snum = snum || this.currentWindow
      if (startTime >= endTime) {
        this.$message.warning('请选择正确的时间')
        return false
      }
      this.videoPlayer.closeVideo({ snum, isAll: false })
      const query = {
        data: {
          channelId: this.channelId,
          recordSource: '3', // 录像来源：2=设备，3=中心
          startTime: startTime, // 开始时间(时间戳：单位秒)
          streamType: '1', // 码流类型：1=主码流， 2=辅码流，3=辅码流2
          endTime: endTime, // 结束时间(时间戳：单位秒)
          recordType: '1', // 录像类型：1=远程录像，2=报警录像，6=定时录像（和查询到的类型保持一致即可）
        },
      }
      const res = await dhServer.startPlayback(query)
      if (res && res.code === 1000 && res.data) {
        const urlList = res.data.url.split('|')
        this.backPlayUrl = `${urlList[1]}?token=${res.data.token}&trackID=701`
        this.setPlayback({
          path: this.backPlayUrl,
          records: [],
          redirect: false,
          snum,
          startTime,
          endTime,
          playStartTime: startTime,
          playEndTime: endTime,
        })
      }
    },
    /**
     * @description: 初始化视频插件
     * @return {*}
     */

    initVideo() {
      if (this.videoPlayer) {
        this.destroy()
      }
      this.videoPlayer = new VideoPlayer({
        videoId: this.videoId,
        windowType: this.windowType, // 0 为普通预览；1 为普通回放；2 为预览不含分屏按钮；3 为回放不含分屏按钮
        connectTime: this.connectTime, //尝试连接事件，默认60s，一定时间连接断开，并弹出下载插件提示
        shieldClass: this.shieldClass, // 遮挡区域的 Class
        showBar: this.showBar, // 是否显示下方控制栏。 true: 显示， false：隐藏
        num: this.num, // 子窗口个数
        // 窗口初始化成功
        connectSuccess: () => {
          this.DHPVersion = window.dhPlayerControl.DHPlayerVersion
        },
        //关闭视频窗口回调
        closeWindowSuccess: ({ isAll, snum }) => {
          this.$emit('closeWindowSuccess', {
            isAll,
            snum,
          })
        },
        // 获取当前选中的窗口
        getCurrentWindow: (snum) => {
          this.currentWindow = snum
        },
        // 点击控件窗口触发返回当前点击的窗口index
        clickWindow: (snum) => {
          this.currentWindow = snum
          console.log(`当前点击了第${snum}个窗口`)
        },
        // 控件切换窗口数量时触发此方法返回当前窗口总数
        changeDivision: (divisionNum) => {
          this.divisionNum = divisionNum
          this.$emit('changeDivision', divisionNum)
        },
        connectClose: () => {
          this.videoPlayer = null
        },
        createSuccess: (e) => {
          if (!this.showBar) {
            this.setShowBar(false)
          }
          this.getRTSPURL()
        },
        switchStartTime: ({ startTime, snum }) => {
          this.switchStartTime(startTime, snum)
        },
        replay: (snum) => {
          //录像回放播放结束回调，返回窗口
          console.log(snum, 'snum-------------')
        },
      })
    },
    /**
     * @description: 摧毁视频
     * @return {*}
     */

    destroy() {
      if (this.videoPlayer) {
        this.videoPlayer.destroy()
      }
    },
    /**
     * @description: 录像回放时间栏拖拽回调
     * @param {*} startTime
     * @param {*} snum
     * @return {*}
     */

    switchStartTime(startTime, snum) {
      const endTime = parseInt(Moment().valueOf() / 1000)
      this.startPlay(startTime, endTime, snum)
    },
    //隐藏插件更新/下载提示
    hiddenDhp() {
      window.DHPVisible = this.DHPVisible = false
    },
    //隐藏窗口
    hideWindow(callback) {
      this.videoPlayer.hide(callback)
    },
    //显示窗口
    showWindow(callback) {
      this.videoPlayer.show(callback)
    },
    //显隐控制栏
    setShowBar(show) {
      this.videoPlayer.showControlBar(show)
    },
    // 是否开启拖拽
    setDragEnable(enable) {
      this.videoPlayer.setWindowDragEnable({ enable })
    },
    // 全屏
    setFullScreen() {
      this.videoPlayer.setFullScreen()
    },
    //获取录像回放/实时预览路径
    async getRTSPURL() {
      const channelList = this.channelId.split(',')
      const currentIndex = _.findIndex(this.DivisionMap, (el) => {
        return channelList.length <= el
      })
      this.changeDivision(this.DivisionMap[currentIndex])
      _.forEach(channelList, async (el, index) => {
        const url = await this.livePreview(el)
        if (url) {
          this.setRealTime({
            path: url,
            redirect: false,
            snum: index + 1,
          })
        }
      })
    },
    // 实时预览
    setRealTime(options) {
      this.videoPlayer.realmonitor({
        ...options,
      })
    },
    // 回放
    setPlayback(options) {
      this.videoPlayer.playback({ ...options })
    },
    changeDivision(divisionNum) {
      this.videoPlayer.changeDivision(divisionNum)
    },
    //隐藏插件更新/下载提示
    hiddenDhp() {
      window.DHPVisible = this.DHPVisible = false
    },
    //隐藏窗口
    hideWindow(callback) {
      this.videoPlayer.hide(callback)
    },
    //显示窗口
    showWindow(callback) {
      this.videoPlayer.show(callback)
    },
    // 是否显示规划线
    isEnableIvs(option) {
      this.videoPlayer.isEnableIvs(option)
    },
    //元素遮挡处理
    windowShield(option) {
      this.videoPlayer.windowShield(option)
    },

    /**
     * @description: 云台控制
     * @param {*} command 方向
     * @param {*} action 关闭or开启
     * @return {*}
     */

    async controlCamera(command, action) {
      const query = {
        data: {
          channelId: this.channelId,
          direct: this.controlCameraList[command],
          stepX: this.speed || 4,
          stepY: this.speed || 4,
          command: action,
          extend: '',
        },
      }
      await dhServer.controlCameraMove(query)
    },
    /**
     * @description: 控制云台镜头的变焦
     * @param {*} data
     * @return {*}
     */

    async operateCamera(command, operateType, direct) {
      const query = {
        data: {
          channelId: this.channelId,
          operateType,
          direct,
          step: String(this.speed),
          command: command,
          extend: '',
        },
      }
      await dhServer.operateCamera(query)
    },
  },
  beforeDestroy() {
    this.destroy()
  },
}
</script>
<style lang="scss" scoped>

$danger: rgba(247, 95, 95, 0.8);
$success: #1baba6;
.controlImg {
  width: 30px;
  &_up {
    transform: rotate(90deg);
  }
  &_right {
    margin-left: 50px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
  }
}
/deep/.el-date-editor {
  width: 100%;
  .el-input--suffix .el-input__inner {
    padding-right: 5px !important;
  }
}
.control_item {
  background-color: rgba(24, 41, 72, 0.5) !important;
  padding: 0px 10px 10px 10px;
  height: calc(100% - 30px);
}
// switch相关
/deep/.el-switch {
  &__label {
    color: #fff !important;
    &.is-active {
      color: #1890ff !important;
    }
  }
  &__core {
    border-color: $danger !important;
    background-color: $danger !important;
  }
}
/deep/.el-switch.is-checked {
  .el-switch__core {
    border-color: $success !important;
    background-color: $success !important;
  }
}

</style>
